/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Returned_PlaceholderInputs */

const vi_order_carrier_returned_placeholder = /** @type {(inputs: Order_Carrier_Returned_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: 2/2 kiện hoàn về, nguyên đai nguyên kiện`)
};

/**

* @param {Order_Carrier_Returned_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_returned_placeholder = /** @type {((inputs?: Order_Carrier_Returned_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Returned_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_returned_placeholder(inputs)
});